import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    totalCount: 0,
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    delete(context, data) {
      return api.delete(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    }
  }
};

appStore.registerModule('orderTaskProject', store);
